<template>
  <v-layout>
    <v-flex xs12>
      <v-card class="elevation-3 px-2">
        <v-container>
          <v-layout align-center>
            <v-flex>
              <v-menu
                offset-y
                transition="scale-transition"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    readonly
                    clearable
                    dense
                    hide-details
                    height="25"
                    color="secondary"
                    v-on="on"
                    label="Начальная дата"
                    v-model="start"
                  ></v-text-field>
                </template>
                <v-date-picker
                  color="secondary"
                  v-model="start"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-icon class="mx-1">{{ icons.arrowLeftRight }}</v-icon>
            </v-flex>
            <v-flex>
              <v-menu
                offset-y
                transition="scale-transition"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    readonly
                    clearable
                    dense
                    hide-details
                    height="25"
                    color="secondary"
                    v-on="on"
                    label="Конечная дата"
                    v-model="end"
                  ></v-text-field>
                </template>
                <v-date-picker color="secondary" v-model="end"></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { Icon } from "@/helpers";

export default {
  methods: {
    startChanged: function (date) {
      this.$emit("start-date-changed", date);
    },
    endChanged: function (date) {
      this.$emit("end-date-changed", date);
    },
  },
  watch: {
    start: function (value) {
      this.startChanged(value);
    },
    end: function (value) {
      this.endChanged(value);
    },
  },
  data: () => ({
    start: "",
    end: "",
    icons: {
      arrowLeftRight: Icon.arrowLeftRight,
    },
  }),
};
</script>
